import { Component,
  OnInit } from '@angular/core';
import { ActivatedRoute,
  Router } from '@angular/router';

/**
 * This class represents the lazy loaded PhotoComponent.
 */
@Component({
	selector: 'app-photo',
	templateUrl: './photo.component.html',
	styleUrls: ['./photo.component.css']
})

export class PhotoComponent implements OnInit {
	strSlugId: string;
	bIsLoading: boolean;
	bIsNext: boolean;

	nTotoalStep: number;
	nCurrentStep: number;

	constructor(
		private route: ActivatedRoute,
		private router: Router
	) {
		this.bIsLoading = false;
		this.bIsNext = false;
	}

	ngOnInit() {
		this.route.params.subscribe(params=> {
			this.strSlugId = params['slugId'];
		});
	}

	next() {
		if(this.bIsNext) {
			this.router.navigate(['/estimate', this.strSlugId]);
		}
	}

	getData(event: any) {
		this.nTotoalStep = event.totalStep;
		this.nCurrentStep = event.currentStep;
		this.bIsLoading = true;
	}

	getStepStatus(event: any) {
		if(event) {
			this.bIsNext = true;
		} else {
			this.bIsNext = false;
		}
	}
}




// WEBPACK FOOTER //
// /home/rubylover/Work/new_vin_photo/site/web/src/app/photo/photo.component.ts